import { useEffect, useState } from "react";

/**
 * `window.matchMedia` reativo. Usado pelo `FilterPanel` (ui/FilterPanel.tsx)
 * pra decidir popover suspenso (desktop) vs Drawer (mobile) no MESMO corte
 * de 60rem que o resto do shell usa pra esconder a coluna fixa antiga —
 * ver `.filters-popover`/`.filters-trigger` em index.css.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (): void => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
